<template>
	<TheLoader :isLoading="loading" />
	<div class="row">
		<div class="col-md-2"></div>
		<div class="col-md-8">
			<div class="card card-info">
				<div class="card-header">
					<h3 class="card-title"><i class="fas fa-key mr-2"></i> Thay đổi thông tin cá nhân</h3>
					<div class="card-tools"></div>
				</div>
				<div class="card-body form-horizontal">
					<form>
						<div class="card-body">
							<div class="form-group row">
								<label class="col-sm-4 col-form-label">
									Họ tên<span class="text-danger">(*)</span>
								</label>
								<div class="col-sm-8">
									<input type="text" :class="['form-control', { 'is-invalid': errors.hoTen }]"
										placeholder="Nhập họ tên" v-model="modelRec.hoTen" />
									<div class="text-danger" v-if="errors.hoTen">{{ errors.hoTen }}</div>
								</div>
							</div>

							<TheChangeInforSelect title="Giới tính" :options="category_GIOITINH"
								:initialValue="modelRec.gioiTinh" :error="errors.gioiTinh" :isMultiple="false"
								:isReadOnly="isReadonly" :isAllowClear="true" :isRequire=false
								@onChange="(v) => modelRec.gioiTinh = v" :key="tempKey" />
							<div class="form-group row">
								<label class="col-sm-4 col-form-label">
									Email
								</label>
								<div class="col-sm-8">
									<input type="text" :class="['form-control', { 'is-invalid': errors.email }]"
										placeholder="Nhập Email" v-model="modelRec.email" />
									<div class="text-danger" v-if="errors.email">{{ errors.email }}</div>
								</div>
							</div>
							<div class="form-group row">
								<label class="col-sm-4 col-form-label">
									Số điện thoại<span class="text-danger">(*)</span>
								</label>
								<div class="col-sm-8">
									<input type="text" :class="['form-control', { 'is-invalid': errors.sdt }]"
										placeholder="Nhập số điện thoại" v-model="modelRec.sdt" />
									<div class="text-danger" v-if="errors.sdt">{{ errors.sdt }}</div>
								</div>
							</div>

							<TheChangeInforSelect title="Đơn vị" :options="category_DONVI"
								:initialValue="modelRec.donViId" :error="errors.donViId" :isMultiple="false"
								:isReadOnly="isReadonly" :isAllowClear="true" :isRequire=false
								@onChange="(v) => modelRec.donViId = v" :key="tempKey" />


							<TheChangeInforSelect title="Chức danh" :options="category_CHUCDANH"
								:initialValue="modelRec.chucDanhId" :error="errors.chucDanhId" :isMultiple="false"
								:isReadOnly="isReadonly" :isAllowClear="true" :isRequire=false
								@onChange="(v) => modelRec.chucDanhId = v" :key="tempKey" />


							<TheChangeInforSelect title="Quận huyện" :options="category_cQUANHUYEN"
								:initialValue="modelRec.quanHuyenId" :error="errors.quanHuyenId" :isMultiple="false"
								:isReadOnly="isReadonly" :isAllowClear="true" :isRequire=false
								@onChange="(v) => onChange_cQuanHuyen(v)" :key="tempKey" />

							<TheChangeInforSelect title="Phường xã" :options="category_cPHUONGXA"
								:dropdownParent="modalName" :initialValue="modelRec.phuongXaId"
								:error="errors.phuongXaId" :isMultiple="false" :isReadOnly="isReadonly"
								:isAllowClear="true" :isRequire=false @onChange="(v) => onChange_cPhuongXa(v)"
								:key="tempKey" />

							<TheChangeInforSelect title="Khóm ấp" :options="category_cKHOMAP"
								:initialValue="modelRec.khomApId" :error="errors.khomApId" :isMultiple="false"
								:isReadOnly="isReadonly" :isAllowClear="true" :isRequire=false
								@onChange="(v) => onChange_cKhomAp(v)" :key="tempKey" />

							<TheChangeInforSelect title="Tổ dân phố" :options="category_cTODANPHO"
								:initialValue="modelRec.toDanPhoId" :error="errors.toDanPhoId" :isMultiple="false"
								:isReadOnly="isReadonly" :isAllowClear="true" :isRequire=false
								@onChange="(e) => { modelRec.toDanPhoId = e }" :key="tempKey" />

							<TheChangeInforSelect title="Đường phố" :options="category_DUONGPHO"
								:initialValue="modelRec.duongPhoId" :error="errors.duongPhoId" :isMultiple="false"
								:isReadOnly="isReadonly" :isAllowClear="true" :isRequire=false
								@onChange="(e) => { modelRec.duongPhoId = e }" :key="tempKey" />

							<div class="form-group row">
								<label class="col-sm-4 col-form-label">
									Số nhà
								</label>
								<div class="col-sm-8">
									<input type="text" :class="['form-control', { 'is-invalid': errors.soNha }]"
										placeholder="Nhập số nhà" v-model="modelRec.soNha" />
									<div class="text-danger" v-if="errors.soNha">{{ errors.soNha }}</div>
								</div>
							</div>

							<div class="form-group row">
								<label class="col-sm-4 col-form-label">
									Địa chỉ
								</label>
								<div class="col-sm-8">
									<input type="text" :class="['form-control', { 'is-invalid': errors.diaChi }]"
										placeholder="Nhập địa chỉ" v-model="modelRec.diaChi" />
									<div class="text-danger" v-if="errors.diaChi">{{ errors.diaChi }}</div>
								</div>
							</div>

						</div>
					</form>
				</div>
				<div class="card-footer">
					<!-- <button type="button" class="btn btn-outline-secondary" @click="onReset">Reset</button> -->
					<button type="button" class="btn btn-outline-info float-right" @click="onSubmit"
						:disabled="submitted">Đổi thông tin cá nhân</button>
				</div>
			</div>
		</div>
		<div class="col-md-2"></div>
	</div>

</template>

<script>
import $ from 'jquery';
import { mapState, mapActions } from 'vuex';
import config from '@/config/prod.env';
import { common } from '@/helper/common';
import TheChangeInforSelect from '@/components/authentication/childComponents/TheChangeInforSelect';
import { nguoiDungModel } from '@/models/quantri/nguoiDung.model'
export default {
	name: 'TheChangePassword',
	components: {

		TheChangeInforSelect,
		// TheDatePicker,
		// TheInputTextSelect,
		// TheFilePicker,
	},
	data() {
		return {
			category_GIOITINH: config.GIOITINH,
			category_CHUCDANH: [],
			category_DONVI: [],
			category_DUONGPHO: [],
			category_cQUANHUYEN: [],
			category_cPHUONGXA: [],
			category_cKHOMAP: [],
			category_cTODANPHO: [],

			modelRec: nguoiDungModel.newModel(),
			//model: nguoiDungModel.newFEModel(),
			errors: nguoiDungModel.errors(),
			model: nguoiDungModel.newModel(),
			submitted: false,
			loading: false,

			tempKey: common.randomString(10)
		}
	},
	methods: {
		...mapActions('header', ['setupHeader',]),
		...mapActions('authentication', ['updateAccountInfo',]),
		...mapActions('validate', ['validateRequired', 'validateNumber'],),
		...mapActions('chucDanh', ['getBasicChucDanh']),
		...mapActions('donViQT', ['getBasicDonViQT']),
		...mapActions('quanHuyenDM', ['getBasicQuanHuyenDM']),
		...mapActions('phuongXaDM', ['getBasicPhuongXaDM']),
		...mapActions('khomApDM', ['getBasicKhomApDM']),
		...mapActions('toDanPhoDM', ['getBasicToDanPhoDM']),
		...mapActions('duongPhoDM', ['getBasicDuongPhoDM']),
		...mapActions('nguoiDungQT', ['getPersonalDetailNguoiDungQT']),
		setup() {
			let header = 'Thay đổi thông tin cá nhân';
			this.setupHeader({ header });
		},
		initializeSelect2() {
			$(".select2").select2()
			$(".select2bs4").select2({
				theme: "bootstrap4",
			});
		},

		async onChange_cQuanHuyen(e) {
			let targetValue = e ? e : null
			if (!targetValue || targetValue == '') {
				this.modelRec.quanHuyenId = null
				//
				this.category_cPHUONGXA = []
				this.modelRec.phuongXaId = null
				this.category_cKHOMAP = []
				this.modelRec.khomApId = null
				this.category_cTODANPHO = []
				this.modelRec.toDanPhoId = null
				//
			}
			else {
				this.modelRec.quanHuyenId = targetValue
				//
				this.category_cPHUONGXA = []
				this.modelRec.phuongXaId = null
				this.category_cKHOMAP = []
				this.modelRec.khomApId = null
				this.category_cTODANPHO = []
				this.modelRec.toDanPhoId = null
				this.category_cPHUONGXA = await this.getCategory_PHUONGXA(targetValue)
				//
			}
		},

		async onChange_cPhuongXa(e) {
			let targetValue = e ? e : null
			if (!targetValue || targetValue == '') {
				this.modelRec.phuongXaId = null
				//
				this.category_cKHOMAP = []
				this.modelRec.khomApId = null
				this.category_cTODANPHO = []
				this.modelRec.toDanPhoId = null
				//
			}
			else {
				this.modelRec.phuongXaId = targetValue
				//
				this.category_cKHOMAP = []
				this.modelRec.khomApId = null
				this.category_cTODANPHO = []
				this.modelRec.toDanPhoId = null
				this.category_cKHOMAP = await this.getCategory_KHOMAP(targetValue)
				//
			}
		},

		async onChange_cKhomAp(e) {
			let targetValue = e ? e : null
			if (!targetValue || targetValue == '') {
				this.modelRec.khomApId = null
				//
				this.category_cTODANPHO = []
				this.modelRec.toDanPhoId = null
				//
			}
			else {
				this.modelRec.khomApId = targetValue
				//
				this.category_cTODANPHO = []
				this.modelRec.toDanPhoId = null
				this.category_cTODANPHO = await this.getCategory_TODANPHO(targetValue)
				//
			}
		},

		async detail() {
			this.errors = nguoiDungModel.errors()
			//this.model = nguoiDungModel.newModel()
			let params = {
			}
			await this.getPersonalDetailNguoiDungQT({ params }).then(async resp => {
				if (resp == null) {
					return
				}
				else {
					this.modelRec = resp
					if (this.modelRec.quanHuyenId) this.category_cPHUONGXA = await this.getCategory_PHUONGXA(this.modelRec.quanHuyenId)
					if (this.modelRec.phuongXaId) this.category_cKHOMAP = await this.getCategory_KHOMAP(this.modelRec.phuongXaId)
					if (this.modelRec.khomApId) this.category_cTODANPHO = await this.getCategory_TODANPHO(this.modelRec.khomApId)
					this.tempKey = common.randomString(10)
				}
			});



		},



		async validate(model) {
			let isvalid = true
            this.errors = nguoiDungModel.errors()

            if (!await this.validateRequired(model.hoTen)) {
                this.errors.hoTen = "Nhập họ tên"
                isvalid = false
            }


            if (!await this.validateRequired(model.sdt)) {
                this.errors.sdt = "Nhập số điện thoại"
                isvalid = false
            }
			return isvalid
		},

		async modifySendModel(FEmodel) {
			let sendModel = nguoiDungModel.newModel()
			if (this.code == "update") sendModel.userId = FEmodel.userId
			sendModel.userName = FEmodel.userName
			sendModel.hoTen = FEmodel.hoTen
			sendModel.gioiTinh = FEmodel.gioiTinh == "" ? null : FEmodel.gioiTinh
			sendModel.email = FEmodel.email
			sendModel.sdt = FEmodel.sdt
			sendModel.donViId = FEmodel.donViId == "" ? null : FEmodel.donViId
			sendModel.chucDanhId = FEmodel.chucDanhId == "" ? null : FEmodel.chucDanhId
			sendModel.quanHuyenId = FEmodel.quanHuyenId == "" ? null : FEmodel.quanHuyenId
			sendModel.phuongXaId = FEmodel.phuongXaId == "" ? null : FEmodel.phuongXaId
			sendModel.khomApId = FEmodel.khomApId == "" ? null : FEmodel.khomApId
			sendModel.toDanPhoId = FEmodel.toDanPhoId == "" ? null : FEmodel.toDanPhoId
			sendModel.duongPhoId = FEmodel.duongPhoId == "" ? null : FEmodel.duongPhoId
			sendModel.soNha = FEmodel.soNha
			sendModel.diaChi = FEmodel.diaChi

			return sendModel
		},
		async onSubmit() {
			let sendModel = await this.modifySendModel(this.modelRec)
			this.submitted = true;
			this.loading = true;
			if (await this.validate(sendModel)) {
				await this.updateAccountInfo(sendModel);
			}
			this.submitted = false;
			this.loading = false;
		},





		async getCategory_CHUCDANH() {
			let params = {

			}
			let res = await this.getBasicChucDanh({ params: params })
			//handle
			//Lý do cần xử lý là để format lại theo mô hình
			if (res.length > 0) {
				let handleRes = []
				for (let i = 0; i < res.length; i++) {
					handleRes.push(
						{
							id: res[i].chucDanhId,
							name: res[i].ten
						}
					)
				}
				return handleRes
			}
			return res
		},

		async getCategory_DONVI() {
			let params = {

			}
			let res = await this.getBasicDonViQT({ params: params })
			//handle
			//Lý do cần xử lý là để format lại theo mô hình
			if (res.length > 0) {
				let handleRes = []
				for (let i = 0; i < res.length; i++) {
					handleRes.push(
						{
							id: res[i].donViId,
							name: res[i].ten
						}
					)
				}
				return handleRes
			}
			return res
		},

		async getCategory_QUANHUYEN() {
			let params = {
				tinhTpId: config.TINHTP_SITEID
			}
			let res = await this.getBasicQuanHuyenDM({ params: params })
			//handle
			//Lý do cần xử lý là để format lại theo mô hình
			if (res.length > 0) {
				let handleRes = []
				for (let i = 0; i < res.length; i++) {
					handleRes.push(
						{
							id: res[i].quanHuyenId,
							name: res[i].ten
						}
					)
				}
				return handleRes
			}
			return res
		},

		async getCategory_PHUONGXA(quanHuyenId) {
			let params = {
				quanHuyenId: quanHuyenId
			}
			let res = await this.getBasicPhuongXaDM({ params: params })
			//handle
			//Lý do cần xử lý là để format lại theo mô hình
			if (res.length > 0) {
				let handleRes = []
				for (let i = 0; i < res.length; i++) {
					handleRes.push(
						{
							id: res[i].phuongXaId,
							name: res[i].ten
						}
					)
				}
				return handleRes
			}
			return res
		},

		async getCategory_KHOMAP(phuongXaId) {
			let params = {
				phuongXaId: phuongXaId
			}
			let res = await this.getBasicKhomApDM({ params: params })
			//handle
			//Lý do cần xử lý là để format lại theo mô hình
			if (res.length > 0) {
				let handleRes = []
				for (let i = 0; i < res.length; i++) {
					handleRes.push(
						{
							id: res[i].khomApId,
							name: res[i].ten
						}
					)
				}
				return handleRes
			}
			return res
		},

		async getCategory_TODANPHO(khomApId) {
			let params = {
				khomApId: khomApId
			}
			let res = await this.getBasicToDanPhoDM({ params: params })
			//handle
			//Lý do cần xử lý là để format lại theo mô hình
			if (res.length > 0) {
				let handleRes = []
				for (let i = 0; i < res.length; i++) {
					handleRes.push(
						{
							id: res[i].toDanPhoId,
							name: res[i].ten
						}
					)
				}
				return handleRes
			}
			return res
		},

		async getCategory_DUONGPHO() {
			let params = {

			}
			let res = await this.getBasicDuongPhoDM({ params: params })
			//handle
			//Lý do cần xử lý là để format lại theo mô hình
			if (res.length > 0) {
				let handleRes = []
				for (let i = 0; i < res.length; i++) {
					handleRes.push(
						{
							id: res[i].duongPhoId,
							name: res[i].ten
						}
					)
				}
				return handleRes
			}
			return res
		},
	},
	async mounted() {
		this.initializeSelect2();
		this.setup();

		this.category_CHUCDANH = await this.getCategory_CHUCDANH()
		this.category_DONVI = await this.getCategory_DONVI()
		this.category_cQUANHUYEN = await this.getCategory_QUANHUYEN()
		this.category_DUONGPHO = await this.getCategory_DUONGPHO()

		await this.detail()
	}
}
</script>

<style></style>